module.exports = __webpack_public_path__ + "static/media/readme.f606f899.txt";